(()=>{
  function init(root) {
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const q=s=>root.querySelector(s),qa=s=>[...root.querySelectorAll(s)];
    const track=q('.cvp-track'),slides=qa('.cvp-slide'),thumbs=q('.cvp-thumbs'),dialog=q('.cvp-dialog'),form=q('.cvp-form'),main=q('.cvp-main-buy'),sticky=q('.cvp-sticky');
    if(!track||!slides.length)return;
    let index=0;
    const reduced=()=>matchMedia('(prefers-reduced-motion:reduce)').matches;
    slides.forEach((slide,n)=>{
      const b=document.createElement('button');b.type='button';b.className='cvp-thumb';
      b.setAttribute('aria-label','View '+(slide.querySelector('figcaption')?.textContent||'photo '+(n+1)));
      const im=slide.querySelector('img').cloneNode();im.alt='';im.removeAttribute('srcset');im.removeAttribute('sizes');im.removeAttribute('loading');b.append(im);
      b.addEventListener('click',()=>go(n));thumbs.append(b);
    });
    function sync(n) {
      index=(n+slides.length)%slides.length;
      [...thumbs.children].forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));
      q('.cvp-index').textContent=(index+1)+' / '+slides.length;
      const im=slides[index].querySelector('img');
      dialog.querySelector('img').src=im.currentSrc||im.src;
      dialog.querySelector('img').alt=im.alt;
      dialog.querySelector('footer span').textContent=slides[index].querySelector('figcaption')?.textContent||'';
    }
    function go(n){sync(n);track.scrollTo({left:index*track.clientWidth,behavior:reduced()?'instant':'smooth'})}
    qa('.cvp-prev,.cvp-dialog-prev').forEach(b=>b.onclick=()=>go(index-1));
    qa('.cvp-next,.cvp-dialog-next').forEach(b=>b.onclick=()=>go(index+1));
    let timer;
    track.addEventListener('scroll',()=>{clearTimeout(timer);timer=setTimeout(()=>sync(Math.round(track.scrollLeft/track.clientWidth)),100)},{passive:true});
    [q('.cvp-stage'),dialog].forEach(el=>el.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();go(index+1)}if(e.key==='ArrowLeft'){e.preventDefault();go(index-1)}}));
    let width=track.clientWidth;
    new ResizeObserver(()=>{if(width!==track.clientWidth){width=track.clientWidth;track.scrollTo({left:index*width,behavior:'instant'})}}).observe(track);
    q('.cvp-zoom').onclick=()=>{sync(index);dialog.showModal();syncSticky()};
    q('.cvp-dialog-close').onclick=()=>dialog.close();
    dialog.addEventListener('close',()=>{q('.cvp-zoom').focus();syncSticky()});
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});
    function syncSticky(){
      const keyboard=window.visualViewport&&window.visualViewport.height<innerHeight*.65;
      const pbar=document.querySelector('#PBarNextFrame');
      let bottom=0;
      if(pbar){const r=pbar.getBoundingClientRect();if(r.height>0&&r.top<innerHeight&&r.bottom>=innerHeight-5)bottom=Math.min(100,r.height)}
      root.style.setProperty('--cvp-bottom',bottom+'px');
      const buyRect=main.getBoundingClientRect();
      const fullyVisible=buyRect.top>=0&&buyRect.bottom<=innerHeight-bottom;
      const obstructed=[...document.querySelectorAll('[role="dialog"],#shopify-pc__banner,[data-consent-banner]')].some(el=>{if(root.contains(el)||el.closest('[aria-hidden="true"]'))return false;const r=el.getBoundingClientRect(),style=getComputedStyle(el);return r.width>200&&r.height>100&&r.left<innerWidth-100&&r.right>100&&r.top<innerHeight&&r.bottom>innerHeight-150&&style.visibility!=='hidden'&&Number(style.opacity)>0});
      sticky.hidden=fullyVisible||!!keyboard||dialog.open||obstructed;
    }
    new IntersectionObserver(syncSticky,{threshold:[0,1]}).observe(main);
    window.addEventListener('scroll',syncSticky,{passive:true});
    window.visualViewport?.addEventListener('resize',syncSticky);
    window.addEventListener('resize',syncSticky,{passive:true});
    new MutationObserver(syncSticky).observe(document.body,{childList:true});
    const bar=document.querySelector('#PBarNextFrame');if(bar)new ResizeObserver(syncSticky).observe(bar);
    qa('.cvp-final-buy,.cvp-sticky-buy').forEach(b=>b.onclick=()=>form.requestSubmit(main));
    form.addEventListener('submit',async e=>{
      e.preventDefault();e.stopPropagation();
      const buttons=qa('.cvp-main-buy,.cvp-final-buy,.cvp-sticky-buy'),error=q('.cvp-cart-error'),original=main.textContent;
      error.hidden=true;buttons.forEach(b=>b.disabled=true);main.textContent='Opening checkout…';
      try{
        const r=await fetch(root.dataset.cartAdd,{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
        const data=await r.json();if(!r.ok)throw Error(data.description||data.message||'Please try again.');
        document.dispatchEvent(new CustomEvent('cart:add',{detail:{id:data.variant_id||data.id,qty:1,product:data}}));
        window.location.assign((window.Shopify?.routes?.root||'/')+'checkout');
      }catch(err){error.textContent=err.message;error.hidden=false;error.scrollIntoView({block:'center'});buttons.forEach(b=>b.disabled=false);main.textContent=original}
    });
    const video=q('video'),play=q('.cvp-play');
    play.onclick=()=>video.play().then(()=>{play.hidden=true;video.focus({preventScroll:true})}).catch(()=>{play.querySelector('span').textContent='Try playing again'});
    video.addEventListener('play',()=>play.hidden=true);video.addEventListener('ended',()=>play.hidden=false);
    sync(0);syncSticky();
  }
  document.querySelectorAll('.cvp').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.cvp').forEach(init));
})();
